import React, { useEffect } from "react";
import Highcharts from "highcharts";
require("highcharts/modules/accessibility")(Highcharts);

export default function CostAnalysisGraph({ graphdata,id }) {
  function applyAccessibility(chart) {
    if (chart && chart.renderTo) {
      const svg = chart.renderTo.querySelector("svg.highcharts-root");
      if (svg) {
        setTimeout(() => {
        svg.setAttribute("role", "img");
        svg.setAttribute(
          "aria-label",
          "Pie chart showing forecast accuracy distribution: Great, Good, and Bad forecasting."
        );

        const oldDesc = svg.querySelector("desc");
        if (oldDesc) oldDesc.remove();

        if (chart.series && chart.series.length > 0 && chart.series[0].data?.length > 0) {
          const desc = document.createElementNS("http://www.w3.org/2000/svg", "desc");
          desc.textContent =
            "This pie chart shows the proportion of forecasting accuracy categories. " +
            "It indicates how much of the forecasted demand was classified as Great Forecasting, Good Forecasting, or Bad Forecasting. " +
            `The values are ${chart.series[0].data
              .map((d) => `${d.name}: ${d.y?.toFixed(2) || 0}%`)
              .join(", ")}.`;
          svg.insertBefore(desc, svg.firstChild);
        }
        }, 0);
      }
    }
  }
  var chart = {
    plotBackgroundColor: null,
    plotBorderWidth: null,
    plotShadow: false,
    marginTop: 50,
    events: {
      render: function () {
        applyAccessibility(this);
      },
      redraw: function () {
        applyAccessibility(this);
      }
    }
  };
  var title = {
    text: null,
    align: "left",
    style: {
      fontSize: "14px",
    },
  };
  var credits = {
    enabled: false, // Disable the Highcharts bottom link
  };
  var tooltip = {
    pointFormat: "<strong>{point.percentage:.2f}%</strong>",
    borderWidth: 2,
    style: {
      borderColor: function () {
        return this.point.color; // Set the tooltip box border color to match the point color
      },
      opacity:0.9,
      fontSize:'14px',
    }
  };
  var legend = {
    enabled: false,
    align: "left",
    itemStyle: {
      fontWeight: "bold",
      fontSize: "11px",
    },
  };

  var plotOptions = {
    pie: {
      center: [null, 80],
      dataLabels: {
        enabled: false,
      },

      showInLegend: false,
      point: {
        events: {
          legendItemClick: function(e) {
              return false;
          }
        }
      }
    },
  };
  var series = [
    {
      type: "pie",
      // innerSize: "30%",
      borderRadius: 0,
      data: [
        {
          name: "Great Forecasting",
          //y: summaryReports?.FinancialAnalysis?.perCostOfAssesmentInvestment ,
          y:graphdata?.GREAT_FORECAST,
          //color: "rgb(25, 73, 112)", // Set the background color for 'Ordering Cost'
          color: {
            pattern: {
              path: 'M 0 10 L 10 0',
              width: 10,
              height: 10,
              color: '#FFFFFF',
              backgroundColor: "rgb(25, 73, 112)"
    
            }
        }
        },
        {
          name: "Good Forecasting",
          //y: summaryReports?.FinancialAnalysis?.perCostOfExternalFailures,
          y:graphdata?.GOOD_FORECAST,
          //color: "rgb(210, 219, 14)", // Set the background color for 'Holding Cost'
          color: {
            pattern: {
              path: 'M 0 0 L 10 10 M 9 -1 L 11 1 M -1 9 L 1 11',
              width: 10,
              height: 10,
              color: '#FFFFFF',
              backgroundColor: 'rgb(210, 219, 14)'
            },
          }
        },
        {
          name: "Bad Forecasting",
          //y: summaryReports?.FinancialAnalysis?.perCostofInternalFailure,
          y:graphdata?.BAD_FORECAST,
          //color: "rgb(80, 87, 89)", // Set the background color for 'Product Cost'
          color: {
            pattern: {
                path: 'M 0 5 L 10 5', // Horizontal line
                width: 10,
                height: 10,
                color: '#FFFFFF', // Line color (white)
                backgroundColor: 'rgb(80, 87, 89)' // Background color (red)
            }
          },
        },

        // {
        //   name: "Cost of Preventive  Investments",
        //   //y: summaryReports?.FinancialAnalysis?.perCostOfPreventiveInvestment,
        //   y:200,
        //   color: "rgb(18, 178, 166)",
        // },
        // {
        //   name: "Cost of Other  Investments",
        //  //y: summaryReports?.FinancialAnalysis?.perCostOfRedHerringInvestment,
        //  y:160,
        //   color: "rgb(219, 0, 32)",
        // },
      ],
      states: {
        inactive: {
          enabled: false,
        },
      },
    },
  ];
  var accessibility = {
    enabled: true,
    screenReaderSection: {
        beforeChartFormat: '' // disables the default label
    }
  };
  var json = {};
  json.chart = chart;
  json.credits = credits;
  json.title = title;
  json.tooltip = tooltip;
  json.legend = legend;
  json.series = series;
  json.plotOptions = plotOptions;
  json.accessibility = accessibility;
  const initGraph = () => {
    Highcharts.chart(`${id}`, json);
    //console.log(parseFloat(json?.series[0].data[2].y).toFixed(2));
  };
  useEffect(() => {
    initGraph();
  }, [graphdata,id]);
  return (
    <div
      id={id}
      style={{ height: "340px" }}
      title={title.text}
      aria-label="Cost Analysis Graph"
      className="costAnalysis"
    ></div>
  );
}
